import { DatabaseGwService } from '../database-gw.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class InvoiceReceiptService extends DatabaseGwService {
  URL_PATH: string = "/invoices-receipts";
}
